import React, { Component } from 'react';

import LivingLensService, { ERROR_CODES } from '@services/LivingLens';

interface LivingLensV0Props {
  apiKey: string;
  channelId: string;
  respondentId: string;
  questionId: string;
  mediaTypes: 'video' | 'audio' | 'image'[];
  mediaCountryCode: string;
  mediaLanguageCode: string;
  mediaMinLength?: string;
  mediaMaxLength?: string;
  interfaceLanguageCode: string;
  minWidth?: string;
  maxWidth?: string;
  singleUseMode?: boolean;
  widgetDomain?: string;
  widgetEnvironment?: string;
  region?: string;
  onUploadSuccess: (...args: unknown[]) => unknown;
  onError: (...args: unknown[]) => unknown;
  // https://jira.medallia.com/browse/OA-31511
  dataAllowUploads?: boolean;
}

export default class LivingLensV0 extends Component<LivingLensV0Props> {
  static defaultProps = {
    mediaMinLength: '',
    mediaMaxLength: '',
    dataAllowUploads: false,
    minWidth: '0',
    maxWidth: '700',
    singleUseMode: true,
    region: null
  };

  constructor(props) {
    super(props);

    this.livingLensContainer = `multimedia-${this.props.questionId}`;
    this.mediaCaptureCallbacks = this.mediaCaptureCallbacks.bind(this);
    this.handleErrorLoadingScript = this.handleErrorLoadingScript.bind(this);
    this.LivingLensService = new LivingLensService(
      this.props.widgetDomain,
      this.handleErrorLoadingScript
    );
  }

  mediaCaptureCallbacks(mediaCapture) {
    mediaCapture.onEvent('uploadSuccessful', this.props.onUploadSuccess);
    mediaCapture.onEvent('publishFailed', () => this.props.onError(ERROR_CODES.PUBLISH_FAILED));
    mediaCapture.onEvent('uploadFailed', () => this.props.onError(ERROR_CODES.UPLOAD_FAILED));
    mediaCapture.onEvent('stalledUploadDetected', () =>
      this.props.onError(ERROR_CODES.UPLOAD_STALLED)
    );
    mediaCapture.onEvent('noRecordingDevice', () =>
      this.props.onError(ERROR_CODES.NO_RECORDING_DEVICE)
    );
  }

  handleErrorLoadingScript() {
    this.props.onError(ERROR_CODES.ERROR_LOADING_SCRIPT);
  }

  componentDidMount() {
    const LivingLens = this.LivingLensService.getInstance();
    LivingLens.startMediaCapture({
      target: this.livingLensContainer,
      callback: this.mediaCaptureCallbacks,
      filters: [
        {
          group: 'mec_ballot_id',
          filters: [this.props.respondentId]
        },
        {
          group: 'mec_question_id',
          filters: [this.props.questionId]
        }
      ],
      environment: this.props.widgetEnvironment
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      apiKey,
      channelId,
      respondentId,
      questionId,
      mediaTypes,
      mediaCountryCode,
      mediaLanguageCode,
      mediaMinLength,
      mediaMaxLength,
      interfaceLanguageCode,
      minWidth,
      maxWidth,
      dataAllowUploads,
      singleUseMode,
      region
    } = this.props;

    const dataRegion = region ? { 'data-region': region } : {};

    return (
      <div
        data-livinglens-container={this.livingLensContainer}
        data-apikey={apiKey}
        data-channelid={channelId}
        data-respondentid={respondentId}
        data-questionid={questionId}
        data-media={mediaTypes[0]}
        data-minlength={mediaMinLength}
        data-maxlength={mediaMaxLength}
        data-countrycode={mediaCountryCode}
        data-languagecode={mediaLanguageCode}
        data-interfacelanguage={interfaceLanguageCode}
        data-minwidth={minWidth}
        data-maxwidth={maxWidth}
        data-upload={dataAllowUploads}
        data-singleuse={singleUseMode}
        {...dataRegion}
      />
    );
  }
}
